import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    ListGroup,
    Button,
} from "react-bootstrap";
import {
    faGraduationCap,
    faBriefcase,
    faChartLine,
    faHandshake,
    faSliders,
} from "@fortawesome/free-solid-svg-icons";
import celedu from "../../../images/celedu.jpg";
import PromoBanner from "../../PromoBanner/PromoBanner";

const App6 = () => {
    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Целевое обучение</h2>
            <p>Целевое обучение - это особая форма подготовки специалистов,
                при которой будущий работодатель финансирует образование студента
                или предоставляет ему бюджетное место в вузе.</p>
            <PromoBanner
                title="Целевое обучение"
                description="Это возможность учиться на бюджете и гарантированно быть трудоустроенным сразу после окончания обучения!"
                listItems={[
                    {text: "Более 20 бюджетных мест", icon: faGraduationCap},
                    {text: "Гарантированное трудоустройство", icon: faBriefcase},
                    {text: "Поступление по отдельному конкурсу с большим количеством мест", icon: faChartLine},
                    {text: "Поддержка от заказчика", icon: faHandshake},
                    {text: "Гибкие условия от работодателя", icon: faSliders}
                ]}
                imageSrc={celedu}
                imageAlt="Изображение студентов"
            />
            <Container className="mt-4">
                <Card className="mb-4">
                    <Card.Header as="h5">Обязательства гражданина</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ListGroup variant="flush">
                                <ListGroup.Item>
                                    Освоение образовательной программы, указанной в договоре о
                                    целевом обучении.
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    Осуществление трудовой деятельности в течение не менее трех
                                    лет в соответствии с полученной квалификацией.
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    В случае неисполнения условий договора (отчисление за
                                    неуспеваемость, отказ от трудоустройства) гражданин
                                    выплачивает образовательной организации штраф в размере
                                    расходов федерального бюджета, затраченных на его обучение.
                                </ListGroup.Item>
                            </ListGroup>
                        </Card.Text>
                    </Card.Body>
                </Card>

                <Card className="mb-4">
                    <Card.Header as="h5">
                        Единая цифровая платформа «Работа России»
                    </Card.Header>
                    <Card.Body>
                        <Card.Text>
                            До 10 июня 2025 года предложения о целевом обучении будут
                            опубликованы на Единой цифровой платформе «Работа России». На
                            платформе абитуриент сможет посмотреть предложения о целевом
                            обучении в любом регионе страны и узнать:
                        </Card.Text>
                        <ListGroup variant="flush">
                            <ListGroup.Item>
                                Кем и где он будет работать после обучения.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                Где будет проходить целевое обучение.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                Какие меры поддержки он получит во время учебы.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                Какие требования предъявляет предприятие к студенту, с которым
                                заключает договор, и какие санкции предусмотрены за их
                                несоблюдение.
                            </ListGroup.Item>
                            <ListGroup.Item>Как связаться с предприятием.</ListGroup.Item>
                        </ListGroup>
                    </Card.Body>
                </Card>

                <Card className="mb-4">
                    <Card.Header as="h5">
                        Способы подачи заявки на целевое обучение
                    </Card.Header>
                    <Card.Body>
                        <Card.Text>
                            Для участия в конкурсе на целевое обучение абитуриенту необходимо
                            выбрать предприятие и подать заявку одним из следующих способов:
                        </Card.Text>
                        <ListGroup variant="flush">
                            <ListGroup.Item>
                                <a
                                    href="https://www.gosuslugi.ru/vuzonline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Онлайн через Госуслуги {}
                                </a>
                                или
                                <a
                                    href="https://trudvsem.ru/target-education/search"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {} портал Работа в России
                                </a>
                            </ListGroup.Item>
                            <ListGroup.Item>
                                В бумажном варианте напрямую в ГГУ.
                            </ListGroup.Item>
                        </ListGroup>
                    </Card.Body>
                </Card>

                {/* Дополнительная информация */}
                <Row>
                    <Col md={6}>
                        <Card className="mb-4">
                            <Card.Header as="h5">Важные сроки и условия</Card.Header>
                            <Card.Body>
                                <Card.Text>
                                    <ul>
                                        <li>
                                            Приём документов в рамках квоты на целевое обучение
                                            осуществляется в те же сроки, что и на прочие бюджетные
                                            места. Подробнее можно узнать{" "}
                                            <a
                                                href="https://ggu-pk-land.vercel.app/calendar?filter=2"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                здесь
                                            </a>
                                            .
                                        </li>
                                        <li>
                                            Набор на целевое обучение в ГГУ осуществляется на основе
                                            отдельного конкурса, и абитуриенты, претендующие на
                                            целевые места, зачисляются раньше, чем лица, участвующие в
                                            общем конкурсе.
                                        </li>
                                        <li>
                                            Целевые места, оставшиеся свободными после опубликования
                                            приказов о зачислении в рамках целевой квоты,
                                            предоставляются абитуриентам, участвующим в общем
                                            конкурсе.
                                        </li>
                                    </ul>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6}>
                        <Card className="mb-4">
                            <Card.Header as="h5">Дополнительная информация</Card.Header>
                            <Card.Body>
                                <Card.Text>
                                    Необходимо изучить полный перечень предложений, которые будут
                                    опубликованы заказчиками до 10 июня на Единой цифровой
                                    платформе в сфере занятости и трудовых отношений «Работа в
                                    России», выбрать предложение и подать заявку на заключение
                                    договора о целевом обучении.
                                </Card.Text>
                                <Button
                                    variant="primary"
                                    href="https://trudvsem.ru/target-education/search"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Перейти на платформу «Работа России»
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default App6;